import React from "react";
import {View, TouchableOpacity, Text} from "react-native";

import styles from './pt-doc-picker-styles';

import * as DocumentPicker from 'expo-document-picker';
import PtIcon from "../core/pt-icon/pt-icon";

import {styleVars} from "../../app-style-vars";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";
import {PtDocPickerProps} from './pt-doc-picker-props';

const getLabels = (props:PtDocPickerProps) => {
  return {
    pickFileButtonLabel : props.buttonLabel ? props.buttonLabel : getTranslation('file.upload.button.text') || 'Pick a file to upload',
    pickFileButtonIcon : props.buttonIcon || "document-txt"

  }
};

export default function PtDocPicker(props: PtDocPickerProps) {

  /** labels (translations) */
  const labels = getLabels(props);

  const fileType = props.fileType || '*/*';

  const calcFileSize = (size:number) => {
    return (size/1024 < 1024) ? `${Math.ceil(size / 1024).toString()}kB`: `${Math.ceil(size/1048576).toString()}MB`;
  };

  const getDoc = () => {
    if(props.uploadStatus) {
      props.uploadStatus({
        uploadSuccess: false,
        uploadError: false,
        payload: undefined
      })
    }
    DocumentPicker.getDocumentAsync({type: fileType}).then(res => {
      if(res.type === 'success') {
        if(props.pickerStatus) {
          props.pickerStatus({
            filePicked: true,
            fileName: res.name,
            fileSize: calcFileSize(res.size),
            fileUri: res.uri
          })
        }
      } else {
        console.log('user canceled');
      }
    }).catch(error => {
      if(props.pickerStatus) {
        props.pickerStatus({
          filePicked: false,
          fileName: '',
          fileSize: '',
          fileUri: ''
        });
      }
      console.log('catch, error = ', error);
    })
  };

  return (
    <View>
      <TouchableOpacity onPress={() => getDoc()}>
        <View style={styles.pickerContainer}>
        <View style={styles.iconContainer}>
          <View style={styles.iconWrapper}>
            <PtIcon
              iconName={labels.pickFileButtonIcon}
              iconSize={styleVars.rem(3)}
              iconColor={styleVars.boschDarkBlue}
            />
          </View>
        </View>
        <View style={styles.pickTextContainer}>
          <PtText style={styles.pickText}>{labels.pickFileButtonLabel}</PtText>
        </View>
        </View>
      </TouchableOpacity>
    </View>
  )
}
